import Breadcrumb from '@/components/layouts/breadcrumb';
import { UserMenu } from './user-menu';
import { SidebarTrigger } from '../ui/sidebar';

export default function Navbar() {
  return (
    <nav className="border-b">
      <div className="flex items-center justify-between p-2 px-4">
        <div className="flex items-center gap-2">
          <SidebarTrigger className="sm:hidden" />
          <Breadcrumb />
        </div>
        <UserMenu />
      </div>
    </nav>
  );
}
